// Shared Supabase client instance - ONLY create one instance per app
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase credentials not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables.');
}

// Create a single shared instance
export const supabase = createClient(supabaseUrl || '', supabaseKey || '');

export { supabaseUrl, supabaseKey };
